import styled, { css } from 'styled-components';
import { BurgerNavItemProps } from './BurgerNavDrawer.types';
import { getMaskIconStyles, getSlideAnimation } from '@/styles/helpers';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Overlay } from '@/components/UI/Overlay';

const headStyles = css`
  justify-content: space-between;
  padding-right: 0;
  margin: 20px 0;
  height: 60px;

  @media (min-width: 744px) {
    margin-top: 30px;
  }
`;

const contactUsStyles = css`
  width: auto;
  height: auto;
  font-size: 15px;
`;

export const navItemLeftIconStyles = ({
  name,
  width,
  height,
  margin,
  transition,
}: {
  name: string;
  width?: number;
  height?: number;
  margin?: string;
  transition?: string;
}) => css`
  position: relative;
  &::before {
    content: '';
    background-color: ${({ theme }) => theme.palette.primary.labels};

    ${getMaskIconStyles(name, width, height)};

    ${margin &&
    css`
      margin: ${margin};
    `}

    ${transition &&
    css`
      transition: ${transition};
    `}
  }
`;

const mediumPaddingStyles = css`
  @media (min-width: 744px) {
    padding-right: 40px;
    padding-left: 40px;
  }
`;

const topItemsStyles = css`
  padding: 0 15px;
  margin-bottom: 10px;

  ${mediumPaddingStyles}
`;

const navItemsRowStyles = css`
  ${({ theme }) =>
    theme.isWebView && `padding-bottom: ${theme.insetsBottom / 2}px;`}
`;

export const navItemsColumnStyles = css`
  flex-direction: column;
`;

const footerStyles = css`
  padding: 0 15px;
  margin-bottom: 40px;

  ${mediumPaddingStyles}
`;

export const BurgerNavWrapper = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 80%;
  background-color: ${({ theme }) => theme.palette.primary.background};
  overflow-y: auto;
  z-index: ${({ theme }) => (theme.isWebView ? 9999 : 9998)};

  ${({ $isOpen }) => getSlideAnimation($isOpen, 'left')}
`;

export const BurgerNavigation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const BurgerNavClose = styled(Button)`
  padding: 1px;
  margin-left: auto;
`;

export const BurgerNavItems = styled.div<{
  $isTop?: boolean;
  $isRow?: boolean;
  $gap?: number;
  $isFooter?: boolean;
}>`
  display: flex;
  gap: ${({ $gap }) => $gap ?? 0}px;

  ${({ $isTop }) => $isTop && topItemsStyles}
  ${({ $isRow }) => ($isRow ? navItemsRowStyles : navItemsColumnStyles)}
  ${({ $isFooter }) => $isFooter && footerStyles}
`;

export const BurgerNavItem = styled.div<BurgerNavItemProps>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: ${({ theme }) => theme.palette.primary.labels};

  ${({ $isHead }) => $isHead && headStyles}
  ${({ $isContactUsItem }) => $isContactUsItem && contactUsStyles}
  ${({ $leftIcon }) => $leftIcon && navItemLeftIconStyles($leftIcon)}

  button {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
`;

export const LabelNew = styled(Typography.Caption).attrs({
  $variant: '3',
})`
  display: flex;
  align-items: center;
  height: 21px;
  padding: 0 5px 0 17px;
  font-size: 14px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px ${({ theme }) => theme.palette.overlay[8]};
  color: ${({ theme }) => theme.palette.system.white};
  background-color: ${({ theme }) => theme.palette.brand.main};
  background-image: url('/images/new-label.svg');
  background-repeat: no-repeat;
  background-position: 5px center;
  position: relative;
  bottom: 13px;
  right: 5px;
`;

export const ConnectWithUsTitle = styled(Typography.Body)`
  margin-bottom: 2px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const BurgerNavOverlay = styled(Overlay)`
  z-index: ${({ theme }) => (theme.isWebView ? 9997 : 9996)};
`;
